import { TextType } from '.';

export class TableStrings {
  static DISPLAY_NAME = 'Operations';
  static PROPERTY_NAME = 'lastColumn';
  static TABLE_TEXT_MAX_LENGTH_SHOW = 1;
}

export class TableIcons {
  static ARROW_UP = 'arrow_upward';
  static ARROW_DOWN = 'arrow_downward';
}

export class SortingOrder {
  static ASC = 'asc';
  static DESC = 'desc';
}
export class ClassName {
  static SelectText = 'select-text';
}

export const LabelSelectHeight = '3em';

export const TitleSubTitlePadding = '0.25em';

export const ResetStateSortIcon = 3;

export const BEFORE = 'before';

export const AFTER = 'after';

export const DELETE_CONFIRM_BUTTON_HEIGHT = {
  DEFAULT: '3em',
  THRESHOLD: '3.6em'
};

export const MAT_CARD_PADDING = {
  LANDING_PAGE: '2em 2em 3em',
  SYSTEM_CONFIGURATION: '2em 2em 2.25em',
  USER_ROLE_PERMISSION: '2em 2em 3em'
};

export type sharedConfigPositionType = 'before' | 'after';

export class ButtonWidth {
  static ACTION_WIDTH = '10.75em';
  static SEARCH_ACTION_WIDTH = '9.3em';
}

export const invalidInputCharacters: string[] = ['-', '+', 'e'];
export const NUMBER_SPECIAL_CHARACTER_ALLOW = 12;

export class SharedValidationPatterns {
  static INVALID_CHARACTER_INPUT_REGEX = /[e\+\-]/gi;
  static ALPHA_NUMERIC_PATTERN_REGEX = /[^A-Za-z0-9]/;
  static ALPHA_NUMBERIC_PATTERN_MULTI_REGEX = /[^A-Za-z0-9]/gm;
  static SPECIAL_PATTERN = /[@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g;
}

export class InputFieldConfigValues {
  static MAX_LENGTH = 999;
  static MIN_VALUE = 0;
  static MAX_VALUE = 0;
  static TOOLTIP_DELAY = '0';
  static INPUT_HEIGHT = '2.6em';
}

export class InputFieldTemperatureConfigValues {
  static MIN_VALUE = -99;
  static MAX_VALUE = 99;
}

export class InputFieldThresholConfigValues {
  static MIN_VALUE = 1;
  static MAX_VALUE = 100;
}

export class SharedConstants {
  static ZERO = 0;
  static ONE = 1;
  static EMPTY_STRING = '';
  static EMPTY_STRING_SPACE = ' ';
  static EMPTY_DASH_STRING = '-';
}

export class SharedConfigValues {
  static TOTAL_DOTS_COUNT = 3;
  static INPUT_MAX_LENGTH = 25;
  static TOOL_TIP_DELAY = '100000';
}

export class SharedPropertyNames {
  static IS_DISABLED = 'isDisabled';
}

export class SharedCssClassNames {
  static FOCUS = 'focus';
  static UNFOCUS = 'unfocus';
  static ERROR = 'error';
  static MAT_CALENDAR_BODY_CELL_CONTENT = 'mat-calendar-body-cell-content';
  static RED_TEXT = 'red-text';
  static YELLOW_TEXT = 'yellow-text';
  static ERROR_INPUT = 'error-input';
  static TEXT_LEFT_ALIGN = 'text-left-align';
  static TITLE_SUBTITLE_CONTENT = 'shared-sub-title-content';
  static COMMENT_MSG = 'comment-msg';
}

export class SharedCSSPropertyName {
  static MIN_WIDTH = 'min-width';
  static WHITE_SPACE = 'white-space';
  static WIDTH = 'width';
  static HEIGHT = 'height';
  static BACKGROUND_COLOR = 'background-color';
  static BACKGROUND_IMAGE = 'background-image';
  static BORDER_RADIUS = 'border-radius';
  static PADDING = 'padding';
  static BORDER = 'border';
  static FONT_SIZE = 'font-size';
  static COLOR = 'color';
  static PADDING_TOP = 'padding-top';
}

export class SharedElementSizingUnits {
  static PIXEL = 'px';
}

export class SharedIconTypes {
  static WARNING = 'warning';
  static ERROR = 'error';
}

export class WhiteSpacingOptions {
  static PRESERVE = 'pre';
}

export class TextStyleTypes {
  static TERTIARY: TextType = 'tertiary';
  static TABLE_HEADER: TextType = 'table-header';
  static BUTTON_REGULAR: TextType = 'button-regular';
  static BODY: TextType = 'body';
  static BODY2: TextType = 'body2';
  static TABLE_COLUMN_TITLE: TextType = 'table-column-title';
}

export class ModalPopupIds {
  static DELETE_COMMENT_MODAL = 'delete-comment-popup-modal';
}

export const DATE_CONSTANT = {
  month: 12,
  limitNumberResetMode: 2
}

export const DATE_FORMATS = {
  parse: 'DD',
  display: {
    dateInput: 'DD',
    monthYearA11yLabel: 'MMMM YYYY',
    yearLabel: 'YYYY',
    monthLabel: 'MMMM',
    fullDateFormat: 'dd MMM YYYY',
    appDateformat: 'MM/dd/yyyy'
  }
}

export class DateStrings {
  static INVALID_DATE_ERROR: string = 'Invalid Date';
  static DD_MM_YYYY_FORMAT_DATE__CODE: string = 'en-GB';
  static DD_MM_YYYY_FORMAT: string = 'dd/MM/yyyy';
  static YYYY_MM_DD_FORMAT: string = 'yyyy-MM-dd';
}

export class ColorTheme {
  static Primary: string = 'primary';
}

export class ExpansionPanel {
  static ARROW_UP: string = 'keyboard_arrow_up';
  static ARROW_DOWN: string = 'keyboard_arrow_down';
}

export class IconSizeConfig {
  static ICON_SMALL: string = '1em';
  static ICON_MEDIUM_SMALL: string = '1.25em';
  static ICON_MEDIUM: string = '1.5em';
}

export class VariableNames {
  static TOTAL_NUM_OF_SELECTED_TAGS: string = 'totalNumberOfSelectedTags';
  static NUMBER_OF_SELECTED_FILTER: string = 'numberOfSelectedFilters';
  static CALENDAR_COLUMN_DATA: string = 'calendarColumnData';
  static SELECTED_ITEM_LIST: string = 'selectedItemList';
  static ACTIVE_DISPLAY_LIST: string = 'activeDisplayList';
  static HIDE_ALL_ASN_PO_TITLE_ICONS: string = 'hideAllAsnPoTitleIcons';
  static IS_DELETED_TITLE_ICON_PRESENT: string = 'isDeletedTitleIconPresent';
  static PALLET_DETAILS: string = 'palletDetails';
  static ACTIVE_DEPOT_TYPE: string = 'activeDepotType';
  static RESET_STATUS_DATE_ON_SEARCH: string = 'resetStatusAndDateRange';
  static RESET_STATUS_DATE_ON_CANCEL: string = 'dateAndStatusResetOnCancel';
  static DOOR_SYSTEM_DATA: string = 'doorSystemData';
}

export class DefaultNumberInitializableConstants {
  static ZERO = 0;
  static ONE = 1;
  static TWO: number = 2;
  static THREE: number = 3;
  static FOUR: number = 4;
  static FIVE: number = 5;
  static NEGATIVE_ONE: number = -1;
}

export class loaderDiameter {
  static LOADER_MD = '40';
  static LOADER_LG = '100';
}

export class LoaderSizeTypes {
  static SMALL = 'small';
  static MEDIUM = 'medium';
  static LARGE = 'large';
}

export class LoaderDiameter {
  static LOADER_SM = '15';
  static LOADER_MD = '40';
  static LOADER_LG = '100';
}

export const TOTAL_WIDTH = 100;

export const MOBILE_VIEW_WIDTH = '480px';

export class LazyLoadBuffer {
  static SHORT_BUFFER = 100;
  static MEDIUM_BUFFER = 200;
}

export class TableColumnDividerTypes {
  static RIGHT_ARROW: string = 'arrow_right_alt';
  static VERTICAL_LINE = 'verticleLine';
}

export class CharacterSizeLimits {
  static DEFAULT_LIMIT: number = 250;
  static TAG_NUMBER_DIGITS_LIMIT: number = 19;
  static ADJUST_QUANTITY_ARTICLE_DESCRIPTION_LIMIT: number = 25;
  static ASN_PO_DELIVERY_NOTE_LIMIT: number = 16;
  static PRINTER_BARTENDER_NAME: number = 30;
  static PRINTER_DISPLAY_NAME: number = 30;
}

export class DefaultDateRange {
  static DATE_RANGE: number = 5;
  static REPORTING_DATE_RANGE: number = 6;
}